import { notifications } from '@mantine/notifications';
import { salesOrderControllerGetSalesOrderNoteAttachment } from '@/generated/api/sales-order.ts';
import type { NoteAttachmentDto } from '@/generated/api/pacApi.schemas.ts';

export async function openSalesOrderNoteAttachment(
  salesOrderId: string,
  salesOrderNoteId: string,
  attachment: NoteAttachmentDto,
): Promise<void> {
  try {
    const blob = await salesOrderControllerGetSalesOrderNoteAttachment(
      salesOrderId,
      salesOrderNoteId,
      attachment.id,
    );
    const url = URL.createObjectURL(blob);

    if (
      attachment.mimeType.startsWith('image/') ||
      attachment.mimeType === 'application/pdf'
    ) {
      window.open(url, '_blank', 'noopener,noreferrer');
      window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
      return;
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = attachment.fileName;
    link.click();
    URL.revokeObjectURL(url);
  } catch {
    notifications.show({
      color: 'red',
      title: 'Attachment unavailable',
      message: 'The attachment could not be opened. Try again later.',
    });
  }
}
